import {AppBar,Typography,Toolbar,IconButton,Button} from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import GithubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import Home from './components/home/Home';
import useStyles from './styles';
import Projects from './components/Projects/Projects'
import Education from './components/Education/Education';
import Certificates from './components/Certificates/Certificates';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import { NavLink, Route } from 'react-router-dom';
//  "homepage": "http://akashhegde2012.github.io/profile",
function App() {
	const classes = useStyles();


  return (
    <div className="App">
		<AppBar position="static" className={classes.appBar}>
			<Toolbar>
					<IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
						<a href="https://github.com/akashhegde2012"><GithubIcon color="primary" /></a>
					</IconButton>
					<IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
						<a href="https://www.linkedin.com/in/akash-hegde-4b7805193/"><LinkedInIcon color="primary" /></a>
					</IconButton>
					<NavLink to='/profile/'><Button className={classes.buttons} variant='seceondary'>Home</Button></NavLink>
					<NavLink to='/profile/education'><Button className={classes.buttons}>Education</Button></NavLink>
					<NavLink to='/profile/projects'><Button className={classes.buttons}>Projects</Button></NavLink>
					<NavLink to='/profile/certificates'><Button className={classes.buttons}>Certificates</Button></NavLink>
					
			</Toolbar>
		</AppBar>
	  {/* {page.home && <Home/>}
	  {page.education && <Education/>}
	  {page.projects && <Projects/>}
	  {page.certificates && <Certificates/>} */}
	  <Route path='/profile/' exact component={Home} />
	  <Route path='/profile/education' component={Education} exact />
	  <Route path='/profile/projects' exact component={Projects} />
	  <Route path='/profile/certificates/'  component={Certificates} />
{ 	  <footer className={classes.footer}>
			<Typography variant='h6' align='center' > Thank You </Typography>
			<Typography variant='subtitle1' align='center' color='textSecondary'>
				 <EmailIcon color='primary'/> akashhegde2012@gmail.com 
				 <PhoneAndroidIcon color='primary' /> +8762996089
			</Typography>
		</footer>}
    </div>
  );
}

export default App;
